export function NotificationsModal({ notifications, onClose, formatTime, onTrialNudgeTap }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="notifications-modal" onClick={(e) => e.stopPropagation()}>
        <div className="journal-header">
          <h2>🔔 Notifications</h2>
          <button className="journal-close" onClick={onClose} data-testid="notif-close-btn">×</button>
        </div>
        {notifications.length === 0 ? (
          <div className="journal-empty">
            <p>🌸</p>
            <p>No notifications yet. Share your Aura to start receiving resonances!</p>
          </div>
        ) : (
          <div className="notifications-list">
            {notifications.map((notif) => {
              const isBirthday = notif.type === "birthday";
              const isMilestone = notif.type === "milestone";
              const isReferral = notif.type === "referral_reward";
              const isTrialNudge = notif.type === "trial_nudge";
              return (
                <div
                  key={notif.id}
                  className={`notification-item ${!notif.read ? 'unread' : ''} ${isTrialNudge ? 'trial-nudge' : ''}`}
                  data-testid={`notif-${notif.id}`}
                  onClick={isTrialNudge ? () => onTrialNudgeTap?.() : undefined}
                  style={isTrialNudge ? { cursor: 'pointer' } : undefined}
                >
                  <div className="notif-avatar">
                    {notif.from_user_picture ? (
                      <img src={notif.from_user_picture} alt="" />
                    ) : (
                      <div className="notif-avatar-placeholder">
                        {isBirthday ? "🎂" : isMilestone ? "✨" : isReferral ? "💜" : isTrialNudge ? "⏳" : "✨"}
                      </div>
                    )}
                    {notif.reaction_emoji && (
                      <span className="notif-reaction-emoji">{notif.reaction_emoji}</span>
                    )}
                  </div>
                  <div className="notif-content">
                    {isBirthday ? (
                      <p>
                        <strong>{notif.person_name}'s</strong> birthday is today 🎂 —
                        want me to help you reach out?
                      </p>
                    ) : isMilestone ? (
                      <p>
                        <strong>{notif.content_title || `${notif.milestone_days} days together`}</strong>
                        <br />
                        <em style={{ opacity: 0.85 }}>I wrote you a letter to mark the moment.</em>
                      </p>
                    ) : isReferral ? (
                      <p>
                        <strong>{notif.content_title}</strong>
                        <br />
                        <em style={{ opacity: 0.85 }}>{notif.content_body || "You both got 1 free month of Premium."}</em>
                      </p>
                    ) : isTrialNudge ? (
                      <p>
                        <strong>{notif.content_title}</strong>
                        <br />
                        <em style={{ opacity: 0.85 }}>{notif.content_body} <span style={{ color: '#f9a8d4' }}>Tap to subscribe →</span></em>
                      </p>
                    ) : (
                      <p>
                        <strong>{notif.from_user_name}</strong> resonated with{' '}
                        <em>{notif.content_title}</em>
                      </p>
                    )}
                    <span className="notif-time">{formatTime(notif.created_at)}</span>
                  </div>
                  {!notif.read && <span className="notif-dot"></span>}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
